export enum IndustryScopeType {
  MASTER = 'MASTER',
  OFFERING = 'OFFERING'
}

export interface IndustryCategory {
  id?: number;
  code: string;
  name: string;
  description?: string;
  icon?: string;
  typeScope: IndustryScopeType;
  offeringUuid?: string;
  industries?: Industry[];
}

export interface SelectableCategory extends IndustryCategory {
  labelNameOverride?: string;
  labelDescriptionOverride?: string;
  iconOverride?: string;
  selected: boolean;
  industries: SelectableIndustry[];
}

export interface Industry {
  id?: number;
  industryTypeUuid?: string;
  code: string;
  name: string;
  description?: string;
  icon?: string;
  industryCategoryId?: number;
  typeScope: IndustryScopeType;
  offeringUuid?: string;
}

export interface SelectableIndustry extends Industry {
  labelNameOverride?: string;
  labelDescriptionOverride?: string;
  iconOverride?: string;
  selected: boolean;
}
